import React, { useState, useEffect } from 'react';
import TextInput from '../../layout/forms/TextInput';

const ObjectDescription = ({ state, setState }) => {
    const onChange = (event) => {
        setState({
            ...state,
            objectDescription: event.target.value
        })
    }
    return (
        <TextInput
            label="Description"
            onChange={onChange}
            value={state.objectDescription}
        />
    )
}
export default ObjectDescription